import { createEpic } from "../helpers";

import {
	deleteFiltersDateAsyncAction,
	getFiltersDatesListAsyncAction,
	getFiltersDateAsyncAction,
	postFiltersDateAsyncAction,
	updateFiltersDateAsyncAction,
} from "./leaderboardActions";

export const getFiltersDatesListEpic = createEpic(
	getFiltersDatesListAsyncAction,
	"leaderboard",
	"getFiltersDatesList",
	true
);

export const getFiltersDateEpic = createEpic(
	getFiltersDateAsyncAction,
	"leaderboard",
	"getFiltersDate",
	true
);

export const postFiltersDateEpic = createEpic(
	postFiltersDateAsyncAction,
	"leaderboard",
	"postFiltersDate",
	true
);

export const updateFiltersDateEpic = createEpic(
	updateFiltersDateAsyncAction,
	"leaderboard",
	"updateFiltersDate",
	true
);

export const deleteFiltersDateEpic = createEpic(
	deleteFiltersDateAsyncAction,
	"leaderboard",
	"deleteFiltersDate",
	true
);
